import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { atomSelectedProduct } from "src/storage";

export const useSubHeader = () => {
  const { t } = useTranslation();

  const selectedProduct = useRecoilValue(atomSelectedProduct);

  const path = selectedProduct?.prodottoDesc
    ? `/ ${selectedProduct?.prodottoDesc}`
    : "";

  return {
    t,
    path,
  };
};
